"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentDomain = exports.getCookielessBaseUrl = exports.inferEnv = exports.COOKIE_LESS_DOMAINS = void 0;
exports.COOKIE_LESS_DOMAINS = {
    development: "/",
    staging: "https://m.s.glamcorner.net/",
    production: "https://www.gc-static.com/"
};
exports.inferEnv = function () {
    var hostname = window.location.hostname;
    if (/staging/.test(hostname)) {
        return "staging";
    }
    else if (/local/.test(hostname)) {
        return "development";
    }
    return "production";
};
exports.getCookielessBaseUrl = function () { return exports.COOKIE_LESS_DOMAINS[exports.inferEnv()] || exports.COOKIE_LESS_DOMAINS.production; };
exports.getCurrentDomain = function () {
    return window.location.hostname
        .split(".")
        .slice(-3)
        .join(".");
};
